import { useRouter } from 'next/router'
import React, { FC } from 'react'

const Index: FC = () => {
  const router = useRouter()

  router.replace('/timeline')

  return <></>
}

export default Index
